export interface Toast {
  element: HTMLElement;
  show(message: string, durationMs?: number): void;
}

/** Confirmations courtes (os trouvé, quête terminée, erreur réseau). */
export function createToast(parent: HTMLElement): Toast {
  const element = document.createElement('div');
  element.className = 'toast';
  element.setAttribute('role', 'status');
  element.setAttribute('aria-live', 'polite');
  element.hidden = true;
  parent.append(element);

  let timer: number | undefined;

  return {
    element,
    show(message: string, durationMs = 3200): void {
      element.textContent = message;
      element.hidden = false;
      element.classList.add('is-visible');
      if (timer !== undefined) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        element.classList.remove('is-visible');
        element.hidden = true;
      }, durationMs);
    },
  };
}
